import styled from 'styled-components';

const Header = styled.div`
  min-height: 70px;
  align-items: center;
  display: flex;
  justify-content: space-between;
`;
export default { Header };
